import dayjs from 'dayjs'
import { ThermostatCostSavingsDataPeriod } from './useThermostatCostSavingsViewModel'

export function formatThermostatPeriodLabel(
  period: ThermostatCostSavingsDataPeriod,
) {
  if (period === 'day') {
    return dayjs().format('ddd, MMM D')
  }

  if (period === 'week') {
    return `${dayjs().subtract(6, 'days').format('MMM D')}–${dayjs().format(
      'MMM D',
    )}`
  }

  const previousMonth = dayjs().subtract(1, 'month')
  const previousMonthFormat = previousMonth.month() !== 11 ? 'MMM' : 'MMM YYYY'

  return `${previousMonth.format(previousMonthFormat)}–${dayjs().format(
    'MMM YYYY',
  )}`
}
